import clsx from "clsx";
import styled from "styled-components";
import Link from "next/link";
import { useLocale } from "hooks";
import translation from "./translation";
import Image from "components/Image";
import DateUtils from "utils/DateUtils";
import { Loading } from "components";
import { type SyntheticEvent, useState } from "react";

const CourseCard = ({ data, className, twoLineTitle = true }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { locale, isFA } = useLocale();

  const onLoadStart = (_: SyntheticEvent<HTMLVideoElement, Event>) => {
    setIsLoading(true);
  };

  const onLoadedData = (_: SyntheticEvent<HTMLVideoElement, Event>) => {
    setIsLoading(false);
  };

  return (
    <div className={clsx("tw-w-full tw-flex tw-flex-col", className)}>
      <div
        className={clsx(
          "tw-relative tw-rounded-lg tw-aspect-square tw-overflow-hidden"
        )}
      >
        <div
          className={clsx(
            "tw-flex tw-justify-center tw-items-center tw-h-full",
            {
              "tw-hidden": !isLoading,
            }
          )}
        >
          <Loading />
        </div>
        <Image
          key={data?.image}
          src={
            data?.image
              ? data?.image
              : "/img/khatam_placeholder_banner__blue.jpg"
          }
          alt={data?.alt}
          width={300}
          height={200}
          className={clsx("tw-rounded-lg tw-w-full tw-h-full tw-object-cover", {
            "tw-hidden": isLoading,
          })}
          onLoadStart={onLoadStart}
          onLoadedData={onLoadedData}
          // placeholder="blur"
          // blurDataURL={blurDataURL}
        />
        {/* <img
          src={data.image || "/img/khatam_placeholder_banner__blue.jpg"}
          alt={data.title}
          className="tw-transition-all tw-rounded-lg tw-w-full tw-object-cover tw-h-full"
        /> */}
        <div className="tw-rounded-lg tw-text-lg tw-font-medium tw-absolute tw-w-full tw-h-full tw-flex tw-bg-gradient-to-b tw-items-end tw-top-0 gradiant" />
      </div>
      <span
        className={clsx(
          "tw-text-[#344456] tw-text-base xxxl:tw-text-[18.67px] xxxl:tw-leading-[31.65px] tw-font-bold tw-mt-4 xxxl:tw-mt-5 group-hover:tw-text-[#007FAC] tw-transition-all title",
          { "tw-min-h-[50px] xxxl:tw-min-h-[64px]": twoLineTitle }
        )}
      >
        {data?.title}
      </span>
      {"holdDate" in data && (
        <p className="tw-text-[#344456]/40 tw-text-[13px] xxxl:tw-text-[17.33px] tw-mt-1">
          <span>{translation[locale]?.DATE}: </span>
          {/* <span>{momentJalali(`${data.publish_date?.value}`, 'jYYYY/jM/jD HH:mm:ss').format('dddd jD jMMMM jYYYY')}</span> */}
          <span>
            {isFA
              ? DateUtils.parsePersianhCourseDate(data?.holdDate)
              : DateUtils.parseEnglishCourseDate(data?.holdDate)}
          </span>
        </p>
      )}
      <Link key={data?.id} href={data?.link} passHref hrefLang={locale}>
        <a
          className={clsx(
            "tw-bg-[#007FAC] tw-text-[14px] xxxl:tw-text-[18.67px] tw-text-[white] tw-font-medium tw-py-2.5 tw-rounded-lg tw-text-center hover:tw-bg-zero hover:tw-text-[#007FAC] tw-border tw-border-solid tw-border-[#007FAC] tw-transition-all xxxl:tw-leading-8",
            {
              "tw-mt-2.5 xxxl:tw-my-[13.33px]": twoLineTitle,
              "tw-mt-5 xxxl:tw-my-6": !twoLineTitle,
            }
          )}
        >
          {translation[locale]?.SEE_MORE}
        </a>
      </Link>
    </div>
  );
};

const StyledCourseCard = styled(CourseCard)`
  .title {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .gradiant {
    background: linear-gradient(
      180deg,
      rgba(52, 68, 86, 0) 66.67%,
      rgba(52, 68, 86, 0.7) 100%
    );
  }

  img {
    transition: transform 0.3s;
  }

  &:hover {
    img {
      transform: scale(1.1);
    }
  }
`;
export default StyledCourseCard;
